import Button, {BtnColor} from "../../../components/Button/Button";
import {Link} from "react-router-dom";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {onAppSetMain} from "../../../store/App/actions";
import {HexColorPicker} from "react-colorful";
import EmulatorMainScreen from "../../../components/EmulatorMainScreen/EmulatorMainScreen";
import OutsideClickHandler from 'react-outside-click-handler';
import {useTranslation} from "react-i18next";

const Step3 = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const [tab, setTab] = useState(0)

    const [showBackgroundPicker, setShowBackgroundPicker] = useState(false)
    const [showContentPicker, setShowContentPicker] = useState(false)
    const [showIconsPicker, setShowIconsPicker] = useState(false)
    const [showButtonPicker, setShowButtonPicker] = useState(false)
    const [showCardPicker, setShowCardPicker] = useState(false)

    const { headerFont, bodyFont, backgroundColor, contentColor, iconsColor, buttonColor, cardColor } = useSelector(({ app: { main }}) => main)

    const onChangeHeaderFont = (e) => dispatch(onAppSetMain('headerFont', e.target.value))
    const onChangeBodyFont = (e) => dispatch(onAppSetMain('bodyFont', e.target.value))
    const onChangeBackgroundColor = (value) => dispatch(onAppSetMain('backgroundColor', value))
    const onChangeContentColor = (value) => dispatch(onAppSetMain('contentColor', value))
    const onChangeIconsColor = (value) => dispatch(onAppSetMain('iconsColor', value))
    const onChangeButtonColor = (value) => dispatch(onAppSetMain('buttonColor', value))
    const onChangeCardColor = (value) => dispatch(onAppSetMain('cardColor', value))

    return (
        <div className="mx-12 mt-5">
            <div className="flex justify-between items-end">
                <div className="text-2xl font-bold w-1/3">3. {t('Main Page')}</div>
                <div className="w-52 mb-2 w-1/3">
                    <div className="text-center">{t('Step')} 3 of 4</div>
                    <div>
                        <div className="h-3 relative max-w-xl rounded-full overflow-hidden">
                            <div className="w-full h-full bg-gray-200 absolute" />
                            <div className="h-full bg-indigo-600 absolute" style={{width:'75%'}} />
                        </div>
                    </div>
                </div>
                <div className="flex w-1/3 justify-end">
                    <Link to={'/chain/app?step=2'}>
                        <Button color={BtnColor.gray} className="ml-2 px-10">{t('Back')}</Button>
                    </Link>
                    <Link to={'/chain/app?step=4'}>
                        <Button color={BtnColor.gray} className="ml-2 px-10">{t('Next')}</Button>
                    </Link>
                </div>
            </div>
            <div className="w-1/2 mt-5">
                <div>{t('Customise your landing page with your brand logo and message.')}</div>

                <div className="flex mt-5">
                    <Button color={tab === 0 ? BtnColor.indigo : BtnColor.gray} className="rounded-r-none" onClick={() =>setTab(0)}>
                        {t('Fonts')}
                    </Button>
                    <Button color={tab === 1 ? BtnColor.indigo : BtnColor.gray} className="rounded-l-none" onClick={() =>setTab(1)}>
                        {t('Colors')}
                    </Button>
                </div>
            </div>

            <div className="mt-8 w-full flex" >
                {tab === 0?(
                    <div className=" w-1/2 mr-10">
                        <label className="block">
                            <span className="text-gray-700">{t('Header 1')}</span>
                            <select
                                className="block w-64 mt-1 rounded-md bg-blue-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
                                value={headerFont}
                                onChange={onChangeHeaderFont}
                            >
                                <option value="" />
                                <option value="font-sans">Open Sans</option>
                                <option value="font-mono">Monospace</option>
                                <option value="font-serif">Font Serif</option>
                            </select>
                        </label>
                        <label className="block mt-10">
                            <span className="text-gray-700">{t('Body 1')}</span>
                            <select
                                className="block w-64 mt-1 rounded-md bg-blue-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"
                                value={bodyFont}
                                onChange={onChangeBodyFont}
                            >
                                <option value="" />
                                <option value="font-sans">Open Sans</option>
                                <option value="font-mono">Monospace</option>
                                <option value="font-serif">Font Serif</option>
                            </select>
                        </label>
                    </div>
                ):null}

                {tab === 1?(
                    <div className="w-1/2 flex flex-wrap mr-10 items-baseline content-start">
                        <label className="block relative mr-10 mb-5">
                            <span className="text-gray-700">{t('Background')}</span>
                            <div className="bg-white rounded shadow"
                                 style={{width:50, height:50, backgroundColor: `${backgroundColor}`}}
                                 onClick={() => setShowBackgroundPicker(prevState => !prevState)}
                            />
                            <input type="text"
                                   value={backgroundColor}
                                   autoComplete="off"
                                   onChange={(e) => onChangeBackgroundColor(e.target.value)}
                                   className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-32  shadow-sm sm:text-sm border-gray-300 rounded-md" />
                            {showBackgroundPicker ? (
                                    <OutsideClickHandler onOutsideClick={() => setShowBackgroundPicker(false)} >
                                        <div className="absolute z-10">
                                            <HexColorPicker color={backgroundColor} onChange={onChangeBackgroundColor} />
                                        </div>
                                    </OutsideClickHandler>

                            ) :null}

                        </label>
                        <label className="block relative mr-10 mb-5">
                            <span className="text-gray-700">{t('Content')}</span>
                            <div className="bg-white rounded shadow"
                                 style={{width:50, height:50, backgroundColor: `${contentColor}`}}
                                 onClick={() => setShowContentPicker(prevState => !prevState)}/>
                            <input type="text"
                                   value={contentColor}
                                   autoComplete="off"
                                   onChange={(e) => onChangeContentColor(e.target.value)}
                                   className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-32  shadow-sm sm:text-sm border-gray-300 rounded-md" />
                            {showContentPicker ? (
                                <OutsideClickHandler onOutsideClick={() => setShowContentPicker(false)} >
                                    <div className="absolute z-10">
                                        <HexColorPicker color={contentColor} onChange={onChangeContentColor} />
                                    </div>
                                </OutsideClickHandler>
                            ) :null}
                        </label>
                        <label className="block relative mr-10 mb-5">
                            <span className="text-gray-700">{t('Icons')}</span>
                            <div className="bg-white rounded shadow"
                                 style={{width:50, height:50, backgroundColor: `${iconsColor}`}}
                                 onClick={() => setShowIconsPicker(prevState => !prevState)}
                            />

                            <input type="text"
                                   value={iconsColor}
                                   autoComplete="off"
                                   onChange={(e) => onChangeIconsColor(e.target.value)}
                                   className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-32  shadow-sm sm:text-sm border-gray-300 rounded-md" />
                            {showIconsPicker ? (
                                <OutsideClickHandler onOutsideClick={() => setShowIconsPicker(false)} >
                                    <div className="absolute z-10">
                                        <HexColorPicker color={iconsColor} onChange={onChangeIconsColor} />
                                    </div>
                                </OutsideClickHandler>
                            ) :null}
                        </label>
                        <label className="block relative mr-10 mb-5">
                            <span className="text-gray-700">{t('Button')}</span>
                            <div className="bg-white rounded shadow" style={{width:50, height:50, backgroundColor: `${buttonColor}`}}
                                 onClick={() => setShowButtonPicker(prevState => !prevState)}/>

                            <input type="text"
                                   value={buttonColor}
                                   autoComplete="off"
                                   onChange={(e) => onChangeButtonColor(e.target.value)}
                                   className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-32  shadow-sm sm:text-sm border-gray-300 rounded-md" />
                            {showButtonPicker ? (
                                <OutsideClickHandler onOutsideClick={() => setShowButtonPicker(false)} >
                                    <div className="absolute z-10">
                                        <HexColorPicker color={buttonColor} onChange={onChangeButtonColor} />
                                    </div>
                                </OutsideClickHandler>
                            ) :null}
                        </label>
                        <label className="block relative mr-10 mb-5">
                            <span className="text-gray-700">{t('Card')}</span>
                            <div className="bg-white rounded shadow"
                                 style={{width:50, height:50, backgroundColor: `${cardColor}`}}
                                 onClick={() => setShowCardPicker(prevState => !prevState)}
                            />

                            <input type="text"
                                   value={cardColor}
                                   autoComplete="off"
                                   onChange={(e) => onChangeCardColor(e.target.value)}
                                   className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-32  shadow-sm sm:text-sm border-gray-300 rounded-md" />
                            {showCardPicker ? (
                                <OutsideClickHandler onOutsideClick={() => setShowCardPicker(false)} >
                                    <div className="absolute z-10">
                                        <HexColorPicker color={cardColor} onChange={onChangeCardColor} />
                                    </div>
                                </OutsideClickHandler>
                            ) :null}
                        </label>

                    </div>
                ):null}

                <div className="w-1/2 bg-gray-100 flex justify-center p-5">
                    <EmulatorMainScreen
                        backgroundColor={backgroundColor}
                        contentColor={contentColor}
                        iconsColor={iconsColor}
                        buttonColor={buttonColor}
                        cardColor={cardColor} />
                </div>

            </div>
        </div>
    )
}

export default Step3
